function formMonitor(form) {
  const startTime = Date.now();
  let hasInteraction = false;

  function checkForInteraction() {
    hasInteraction = true;
  }

  const events = ['keydown', 'mousemove', 'touchstart', 'click'];
  events.forEach((event) => {
    form.addEventListener(event, checkForInteraction, { once: true });
  });

  form.getFillTime = function () {
    return Date.now() - startTime;
  };

  form.hasInteraction = function () {
    events.forEach((event) => form.removeEventListener(event, checkForInteraction));

    return hasInteraction;
  };
}

export default formMonitor;
